import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User, GetUsersResponse, CurrentBusinessUnit, BusinessUnitRole, CurrentUserResponse } from '../models/user.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private baseUrl: string = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}

  getUsers(
    page = 1,
    pageSize = 10,
    filters?: {
      username?: string;
      email?: string;
      role_id?: number;
      business_unit_id?: number;
      disabled?: boolean;
    }
  ): Observable<GetUsersResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
      ...(filters?.username && { username: filters.username }),
      ...(filters?.email && { email: filters.email }),
      ...(filters?.role_id && { role_id: filters.role_id.toString() }),
      ...(filters?.business_unit_id && {
        business_unit_id: filters.business_unit_id.toString(),
      }),
      ...(filters?.disabled !== undefined && {
        disabled: filters.disabled.toString(),
      }),
    });

    const url = `${this.baseUrl}/users?${params.toString()}`;
    return this.http.get<GetUsersResponse>(url, { withCredentials: true });
  }

  getUser(id: number): Observable<User> {
    const url = `${this.baseUrl}/users/${id}`;
    return this.http.get<User>(url, { withCredentials: true });
  }

  getCurrentBusinessUnit(): Observable<CurrentBusinessUnit | { message: string; user: User }> {
    const url = `${this.baseUrl}/users/business-unit/get-active`;
    return this.http.get<CurrentBusinessUnit | { message: string; user: User }>(url, { withCredentials: true });
  }

  setCurrentBusinessUnit(id: number) {
    const url = `${this.baseUrl}/users/business-unit/${id}/set-active`;
    return this.http.put(url, {}, { withCredentials: true });
  }

  updateUserStatus(id: number, disabled: boolean) {
    const url = `${this.baseUrl}/users/${id}/status`;
    return this.http.patch(url, { disabled }, { withCredentials: true });
  }

  getCurrentUser(): Observable<CurrentUserResponse> {
    const url = `${this.baseUrl}/users/current`;
    return this.http.get<CurrentUserResponse>(url, { withCredentials: true });
  }
}
